module.exports = __webpack_public_path__ + "img/2.2cf9c688.jpg";